module.exports = __webpack_public_path__ + "static/media/ipad-comments.bcdf9b4f.jpg";